// Story 213 — C1 step 3: while the session has vigilance, Jupiter remembers it so that, after a reload
// on any screen, it asks Sun for it. Without the mark Jupiter never asks (CA10). The mark is a
// convenience, not security: deleting it stops the frames and Sun covers by RN15.
export const VISION_MARK_KEY = 'mic-vision-watch'

export const hasVisionMark = () => {
  try {
    return window.localStorage.getItem(VISION_MARK_KEY) !== null
  } catch (exception) {
    return false
  }
}

export const setVisionMark = () => {
  try {
    window.localStorage.setItem(VISION_MARK_KEY, 'true')
  } catch (exception) {
  }
}

export const clearVisionMark = () => {
  try {
    window.localStorage.removeItem(VISION_MARK_KEY)
  } catch (exception) {
  }
}
